import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";

var firebaseConfig = {
  apiKey: "AIzaSyBtsReNZf3OTnvUAyMNj-BCnvd2Z845ofw",
  authDomain: "live-chat-defff.firebaseapp.com",
  projectId: "live-chat-defff",
  storageBucket: "live-chat-defff.appspot.com",
  messagingSenderId: "706856259560",
  appId: "1:706856259560:web:d60ea0f35ba8672220de5d",
  measurementId: "G-LGTBDYBYQD"
};

// init firebase
firebase.initializeApp(firebaseConfig);

const projectAuth = firebase.auth();
const projectFirestore = firebase.firestore();
const timestamp = firebase.firestore.FieldValue.serverTimestamp;

export { projectAuth, projectFirestore, timestamp };
